import styled from 'styled-components'
import { Modal } from '@enterprise-ui/canvas-ui-react'

export const StyledSurveyForm = styled(Modal)`
  z-index: 10;
  .C-Modal__closeButton {
    display: none;
  }
  .survey-minimize-button {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
  .question-sub-label {
    font-size: var(--canvas-font-size--sm);
    line-height: 21px;
    margin-top: 4px;
  }
  .question-hint-message {
    color: #ae570f;
    font-size: var(--canvas-font-size--xs);
    line-height: 21px;
    font-weight: var(--canvas-font-weight--normal);
  }
  .question-tooltip {
    .C-Tooltip__Content {
      max-width: 200px;
      font-size: var(--canvas-font-size--sm);
      line-height: 21px;
      font-weight: var(--canvas-font-weight--normal);
    }
    .info-icon {
      margin-left: 5px;
    }
  }
  .C-Modal__container {
    width: 90vw;
    max-width: 680px;
    .C-Modal__container__content {
      position: relative;
      padding: 60px 30px 30px;
      height: 80vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .starting-step-container {
        height: 100%;
        .starting-step-body {
          max-width: 500px;
          text-align: center;
          height: calc(100% - 50px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h1 {
            font-size: var(--canvas-font-size--3x);
            font-weight: var(--canvas-font-weight--bold);
            line-height: 60px;
            margin-bottom: var(--canvas-spacing--md);
          }
          .C-Button.isDisabled {
            color: var(--canvas-helper-color--grey01);
            border-color: rgba(102, 102, 102, 0.5);
            background: var(--canvas-helper-color--grey07);
            font-size: var(--canvas-font-size--xs);
            font-weight: var(--canvas-font-weight--normal);
            line-height: 16px;
            svg {
              margin-right: 5px;
            }
            &:hover {
              color: var(--canvas-helper-color--grey01);
              border-color: rgba(102, 102, 102, 0.5);
              background: var(--canvas-helper-color--grey07);
            }
          }
          p {
            font-size: var(--canvas-font-size--sm);
            font-weight: var(--canvas-font-weight--normal);
            line-height: 21px;
            margin: 30px 0;
          }
        }
        .starting-step-footer {
          text-align: center;
          min-height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: end;
          .btn-remind-later {
            font-size: var(--canvas-font-size--md);
            line-height: 24px;
            font-weight: 500;
            max-width: 180px;
            margin: auto;
            margin-bottom: 5px;
            &[aria-expanded='true'] {
              background: var(
                --canvas-background-color--interactive-contrast-weak-active
              );
              border-color: var(
                --canvas-background-color--interactive-contrast-weak-active
              );
              color: var(--canvas-font-color--interactive-contrast);
            }
          }
          p {
            font-size: var(--canvas-font-size--xs);
            line-height: 18px;
            font-weight: var(--canvas-font-weight--normal);
            color: var(--canvas-font-color--secondary);
          }
        }
      }
      .final-step {
        max-width: 500px;
        text-align: center;
        .final-step-icon {
          font-size: var(--canvas-font-size--3x);
        }
        h2 {
          font-size: var(--canvas-font-size--3x);
          font-weight: var(--canvas-font-weight--bold);
          line-height: 60px;
          margin-bottom: var(--canvas-spacing--md);
        }
        p {
          font-size: var(--canvas-font-size--sm);
          font-weight: var(--canvas-font-weight--normal);
          line-height: 21px;
        }
      }
      .steps-container {
        max-width: 620px;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        .steps-count {
          font-weight: var(--canvas-font-weight--normal);
          font-size: var(--canvas-font-size--xs);
          line-height: 18px;
          color: var(--canvas-font-color--placeholder);
        }
        .step-title {
          font-weight: var(--canvas-font-weight--bold);
          font-size: var(--canvas-font-size--2x);
          line-height: 40px;
          padding: 10px 0;
        }
        .step-desc {
          font-weight: var(--canvas-font-weight--normal);
          font-size: var(--canvas-font-size--sm);
          line-height: 21px;
          color: var(--canvas-font-color--dropdown-item);
          margin-bottom: 40px;
        }
        .question-container {
          margin-bottom: var(--canvas-spacing--md);
          label {
            font-weight: var(--canvas-font-weight--bold);
            font-size: var(--canvas-font-size--lg);
            line-height: 25px;
          }
          .C-Input {
            padding: var(--canvas-spacing--md);
          }
          .question-description {
            font-size: var(--canvas-font-size--sm);
            line-height: 21px;
            color: var(--canvas-font-color--placeholder);
            margin: 5px 0 16px;
          }
          .textarea-question {
            margin: 16px 0 40px;
          }
          .question-error-message {
            flex-basis: 100%;
            width: 100%;
            color: var(--canvas-global-color--target);
            font-size: var(--canvas-font-size--xs);
          }
          .option-contianer {
            display: flex;
            flex-wrap: wrap;
            margin: 16px 0 40px;
            gap: 10px;
            .C-Button {
              height: 60px;
              max-width: 25%;
              flex-grow: 1;
              font-size: var(--canvas-font-size--md);
              line-height: 24px;
              padding-left: 8px;
              padding-right: 8px;
              font-weight: var(--canvas-font-weight--normal);
              background: var(--canvas-background-color--default-contrast-weak);
              border-color: var(
                --canvas-background-color--default-contrast-weak
              );
              &.selected {
                border-color: var(--canvas-font-color--interactive);
                background: var(--canvas-font-color--interactive);
                color: var(--canvas-font-color--contrast-weak);
                font-weight: var(--canvas-font-weight--bold);
              }
            }
          }
        }
        .step-action {
          padding-top: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .step-action-end {
            margin-left: auto;
            svg {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
`

export const StyledSurveyTimer = styled.div`
  position: fixed;
  bottom: 0;
  right: 10px;
  z-index: 6;
  background: var(--canvas-background-color--default-contrast-weak);
  padding: 10px 20px;
  min-width: 500px;
  display: flex;
  justify-content: flex-end;

  .C-Button {
    background: #c0ff00;
    font-size: var(--canvas-font-size--sm);
    line-height: 21px;
    font-weight: 500;
    color: #0f1115;
    border-color: #c0ff00;
    margin-right: 10px;

    &:hover {
      background: #a0d000;
      border-color: #a0d000;
      color: #0f1115;
    }
  }
  svg {
    margin-right: 5px;
  }
  .survey-timer {
    color: var(--canvas-font-color--secondary);
    font-size: var(--canvas-font-size--xs);
    line-height: 18px;
    font-weight: var(--canvas-font-weight--normal);

    strong {
      color: var(--canvas-font-color--default);
      font-weight: 500;
    }
  }
`
